/*
 * File: /src/services/leadTypeService.js
 * Created Date: Thursday November 4th 2021
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Tuesday, 14th December 2021 3:47:03 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2021 AdBase, Inc.
 */

import { authedAxios } from '../shared/axiosWrapper';
import { S2_LEAD_TYPE_PATH } from '../constants';

export default {
  fetchAll() {
    return authedAxios.get(S2_LEAD_TYPE_PATH);
  },
  fetchById(id) {
    return authedAxios.get(S2_LEAD_TYPE_PATH + id);
  },

  updateLeadType(id, payload) {
    return authedAxios.put(S2_LEAD_TYPE_PATH + id, payload);
  },

  createLeadType(payload) {
    return authedAxios.post(S2_LEAD_TYPE_PATH, payload);
  }
};
